import EmailTemplatePage from '../containers/EmailTemplatePage'
import { homePageUrl, isPPC, isLive } from '../config'
import LandingOrPostPage from '../containers/LandingOrPostPage'
import AuthorPage from '../containers/AuthorPage'

const routes = [
  {
    path: '/',
    comp: LandingOrPostPage,
    exact: true
  },
  {
    path: `${homePageUrl}promo`,
    comp: LandingOrPostPage
  },
  {
    path: `${homePageUrl}author/:id`,
    comp: AuthorPage,
    exact: true
  },
  {
    path: `${homePageUrl}blog/:categoryId/:blogId`,
    comp: LandingOrPostPage,
    exact: true
  },
  {
    path: `${homePageUrl}:categoryId/:gameId`,
    comp: LandingOrPostPage,
    exact: true
  },
  {
    path: `${homePageUrl}:campaigns/:gameId`,
    comp: LandingOrPostPage,
    hasMargin: true
  },
  {
    path: '/:pagePath',
    comp: LandingOrPostPage
  },
  { path: `${homePageUrl}:pagePath`, comp: LandingOrPostPage }
]

if (!isPPC && !isLive) {
  const route = {
    path: ['/downloadhtml', '/downloadhtml/*'],
    comp: EmailTemplatePage,
    exact: true
  }
  routes.splice(1, 0, route)
}

export { routes }
